import { render } from "./ContributorMultiselect.vue?vue&type=template&id=4b3a8670&scoped=true"
import script from "./ContributorMultiselect.vue?vue&type=script&lang=js"
export * from "./ContributorMultiselect.vue?vue&type=script&lang=js"

import "../../../assets/css/Multiselect.min.css?vue&type=style&index=0&lang=css"
import "./ContributorMultiselect.vue?vue&type=style&index=1&id=4b3a8670&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3a8670"]])

export default __exports__